import { render, staticRenderFns } from "./agen-naik-kelas-history-modal.vue?vue&type=template&id=36ef9afc&scoped=true"
import script from "./agen-naik-kelas-history-modal.vue?vue&type=script&lang=js"
export * from "./agen-naik-kelas-history-modal.vue?vue&type=script&lang=js"
import style0 from "./agen-naik-kelas-history-modal.vue?vue&type=style&index=0&id=36ef9afc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ef9afc",
  null
  
)

export default component.exports